import { render } from "./NotesEdit.vue?vue&type=template&id=ac05527a"
import script from "./NotesEdit.vue?vue&type=script&lang=js"
export * from "./NotesEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__